import styled from 'styled-components';

import { mediaConfined, mediaNavExtended } from '@xing-com/layout-tokens';
import { spaceL, spaceXL } from '@xing-com/tokens';

export const Container = styled.div``;

export const StyledRow = styled.div`
  width: 100vw;
  position: absolute;
  left: 0;

  display: grid;
  gap: ${spaceL};
  grid-template-columns: repeat(1, 1fr);
  padding-left: ${spaceL};
  padding-right: ${spaceL};

  @media ${mediaConfined} {
    gap: ${spaceXL};
    grid-template-columns: repeat(2, 1fr);
    padding-left: ${spaceXL};
    padding-right: ${spaceXL};
  }

  @media ${mediaNavExtended} {
    grid-template-columns: repeat(6, 1fr);
  }
`;
